<div class="settings-container">
  <ul
    class="settings-tabs"
    [class.jp-lang]="isJpLang"
    [class.sr-lang]="isSrLang"
    *ngIf="(editState$ | async) === false || isTeamsTab || isSubscriptionsTab; else preview"
  >
    <li class="profile-settings">
      <a routerLink="/settings/profile-settings" routerLinkActive="active">{{
        'auth.settings.profileSettings' | translate
      }}</a>
    </li>
    <li class="organization-settings" *ngIf="isVisibleByRole('org')">
      <a
        routerLink="/settings/organization-settings"
        routerLinkActive="active"
        >{{ 'auth.settings.organisationSettings' | translate }}</a
      >
    </li>
    <li class="team-member" *ngIf="isVisibleByRole('team')">
      <a routerLink="/settings/team-member" routerLinkActive="active">{{
        'auth.settings.team' | translate
      }}</a>
    </li>
    <li class="payment-methods" *ngIf="isVisibleByRole('payments')">
      <a routerLink="/settings/payment-methods" routerLinkActive="active">{{
        'auth.settings.paymentMethods' | translate
      }}</a>
    </li>
    <li class="security">
      <a routerLink="/settings/security" routerLinkActive="active">{{
        'auth.settings.security' | translate
      }}</a>
    </li>
    <li class="subscription" *ngIf="isVisibleByRole('subscription')">
      <a routerLink="/settings/my-subscriptions" routerLinkActive="active">{{
        'auth.settings.mySubscriptions' | translate
      }}</a>
    </li>
    <div class="shrink"></div>
    <button *ngIf="isAllowedForRole" class="edit-button" (click)="enableEdit()">
      {{ 'auth.settings.edit' | translate }}
    </button>
  </ul>

  <ng-template #preview>
    <ul class="settings-tabs disabled-group" [class.jp-lang]="isJpLang" [class.sr-lang]="isSrLang">
      <li aria-disabled="true" class="profile-settings">
        <a
          aria-disabled="true"
          disabled
          href="javascript:void(0)"
          [class.active]="isActiveTabToHighlight('profile-settings')"
          >{{ 'auth.settings.profileSettings' | translate }}</a
        >
      </li>
      <li
        aria-disabled="true"
        class="organization-settings"
        *ngIf="isVisibleByRole('org')"
      >
        <a
          aria-disabled="true"
          disabled
          href="javascript:void(0)"
          [class.active]="isActiveTabToHighlight('organization-settings')"
          >{{ 'auth.settings.organisationSettings' | translate }}</a
        >
      </li>
      <li
        class="team-member"
        aria-disabled="true"
        *ngIf="isVisibleByRole('team')"
      >
        <a
          aria-disabled="true"
          disabled
          href="javascript:void(0)"
          [class.active]="isActiveTabToHighlight('team-member')"
          >{{ 'auth.settings.team' | translate }}</a
        >
      </li>
      <li
        class="payment-methods"
        aria-disabled="true"
        *ngIf="isVisibleByRole('payments')"
      >
        <a
          aria-disabled="true"
          disabled
          href="javascript:void(0)"
          [class.active]="isActiveTabToHighlight('payment-methods')"
          >{{ 'auth.settings.paymentMethods' | translate }}</a
        >
      </li>
      <li class="security" aria-disabled="true">
        <a
          aria-disabled="true"
          disabled
          href="javascript:void(0)"
          [class.active]="isActiveTabToHighlight('security')"
          >{{ 'auth.settings.security' | translate }}</a
        >
      </li>
      <li
        class="subscription"
        aria-disabled="true"
        *ngIf="isVisibleByRole('subscription')"
      >
        <a
          aria-disabled="true"
          disabled
          href="javascript:void(0)"
          [class.active]="isActiveTabToHighlight('subscription')"
          >{{ 'auth.settings.mySubscriptions' | translate }}</a
        >
      </li>
      <div class="shrink"></div>
      <button *ngIf="isTeamsTab && !isSubscriptionsTab" class="save-button" (click)="cancelEdit()">
        {{ 'auth.settings.done' | translate }}
      </button>
      <button *ngIf="!isTeamsTab && !isSubscriptionsTab" class="cancel-button" (click)="cancelEdit()">
        {{ 'auth.settings.cancel' | translate }}
      </button>
      <button *ngIf="!isTeamsTab && !isSubscriptionsTab" class="save-button" (click)="saveChanges()">
        {{ 'auth.settings.save' | translate }}
      </button>
    </ul>
  </ng-template>

  <div class="tab-content">
    <router-outlet></router-outlet>
  </div>
  
</div>
